import { useEffect, useRef } from 'react';
import keycloak from '@/keycloak';
import { ROUTES } from '@/config/routes';

/**
 * Register page — legacy route stub.
 *
 * Registration is now handled entirely by Keycloak's hosted page.
 * Visitors to /register are forwarded there immediately;
 * once Keycloak creates the account they land back at /admin/dashboard, where
 * OnboardingGuard routes them through the organization-registration flow.
 */
export const Register = () => {
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (triggeredRef.current) return;
    triggeredRef.current = true;
    void keycloak.register({
      redirectUri: window.location.origin + ROUTES.HOME,
    });
  }, []);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
};
